import type { FC } from "react";
import { cn } from "../../utils";
import LoaderRing from "./LoaderRing";
import type LoaderSize from "./LoaderSize";

type Props = {
  color?: string;
  size?: LoaderSize;
  ariaLabel?: string;
};

const getSize = (size?: LoaderSize) => {
  switch (size) {
    case "2xs":
      return "w-4 h-4";
    case "xs":
      return "w-6 h-6";
    case "sm":
      return "w-8 h-8";
    case "lg":
      return "w-12 h-12";
    default:
      return "w-10 h-10";
  }
};

const Loader: FC<Props> = ({
  color = "border-border",
  size = "md",
  ariaLabel = "Loading",
}) => (
  <div
    aria-label={ariaLabel}
    role="alert"
    aria-busy="true"
    className={cn(getSize(size), "relative rounded-full")}
  >
    <LoaderRing color={color} delay="-0.45s" />
    <LoaderRing color={color} delay="-0.3s" />
    <LoaderRing color={color} delay="-0.15s" />
    <LoaderRing color={color} delay="0s" />
  </div>
);

export type { default as LoaderSize } from "./LoaderSize";
export default Loader;
